export enum RoleById {
	ITDirector = 1,
	Director_de_BienesFiscales = 2,
	Operador_Dir_de_BienesFiscales = 3,
	Responsable_Patrimonial = 4,
	Operador_Dependencia_Patrimonial = 5,
	Super_Admin = 6
}
